
<template>
     <div class="dashboard-container">
        <component :is="currentRole" v-on:handleLogin="handleLogin" ref="login"/>
    </div>
</template>

<script>
    import loginIndex from './Login/index'
    import loginIndexOne from './Login/indexOne'
    import loginIndexYGS from './Login/indexYGS'
    import loginIndexYiAn from './Login/indexYiAn'
    import { setToken,removeToken } from '@/utils/auth'
    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    // import {removeToken} from '@/utils/auth';
    export default {
        name: 'Login',
        data() {
            return {
                currentRole: 'loginIndex'
            }
        },
        components:{
            loginIndex,loginIndexOne,loginIndexYGS,loginIndexYiAn
        },
        created(){
            if(window.location.host=='insadm.ltylao.com'){
                this.currentRole = 'loginIndex'
            }else if(window.location.host=='xlyjgyl.ltylao.com'){
                this.currentRole = 'loginIndexOne'
            }else if(window.location.host=='ahygs-ins.ltylao.com'){
                this.currentRole = 'loginIndexYGS'
            }else if(window.location.host=='yian.ltylao.com'){
              this.currentRole = 'loginIndexYiAn'
            }else{
                this.currentRole = 'loginIndex'
            }
            this.getAreaList();
        },
        watch: {

        },
        methods: {

            handleLogin(loginForm) {
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+'Staff/Login',
                    data: {
                        timeStr:timeStr,
                        sign:hex_md5( "timeStr=" + timeStr + "&key="+this.$signKey),
                        loginName: loginForm.username,
                        password: loginForm.password,
                    }
                }).then( (response)=> {
                    this.$refs.login.loading = false
                    if(response.data.error == 0){
                        removeToken();
                        window.localStorage.setItem('activeInstitutionCode', null);
                        window.localStorage.setItem('activeStaffCode', null);
                        window.localStorage.setItem('activeMenuTop', null);
                        window.localStorage.setItem('listMenuDTO', null);
                        window.localStorage.setItem('listMenuTop', null);
                        window.localStorage.setItem('listMenuLeft', null);
                        let staffDTO = response.data.data.staffDTO;
                        //设置当前机构的职工Code
                        let staffDTOCopy={}
                        staffDTOCopy.institutionCode=staffDTO.institutionCode
                        // staffDTOCopy.lastLoginTime=staffDTO.lastLoginTime
                        staffDTOCopy.loginName=staffDTO.loginName
                        staffDTOCopy.phone=staffDTO.phone
                        staffDTOCopy.realName=staffDTO.realName
                        staffDTOCopy.roleName=staffDTO.roleName
                        staffDTOCopy.staffCode=staffDTO.staffCode
                        if(staffDTO.institutionDTO != null){
                             //设置自动收费规则
                            if(staffDTO.institutionDTO.institutionArg.chargeTime=="day"){
                                staffDTOCopy.chargeTime = "天"
                            }
                            if(staffDTO.institutionDTO.institutionArg.chargeTime=="month"){
                                staffDTOCopy.chargeTime = "月"
                            }

                            let institutionDTO = staffDTO.institutionDTO;

                            if(institutionDTO.isChain == 1 && institutionDTO.chainType != "son"){
                                let institutionDTO1={}
                                // institutionDTO1.institutionCode=institutionDTO.institutionCode
                                institutionDTO1.isChain=institutionDTO.isChain
                                institutionDTO1.chainType=institutionDTO.chainType
                                institutionDTO1.listSonInstitutionRelDTO=[]
                                // let staffCodes={
                                //     staffCode:institutionDTO.staffDTO.staffCode
                                // }
                                // institutionDTO1.staffDTO=staffCodes

                                let listSonInstitutionRelDTO = institutionDTO.listSonInstitutionRelDTO;
                                if(listSonInstitutionRelDTO.length>0){
                                    listSonInstitutionRelDTO.forEach(element => {
                                        let institutionValue={}
                                        // institutionValue.institutionRelCode=element.institutionRelCode
                                        institutionValue.sonInstitutionCode=element.sonInstitutionCode
                                        institutionValue.sonInstitutionName=element.sonInstitutionName
                                        institutionValue.staffCode=element.sonInstitutionStaffDTO.staffCode
                                        institutionDTO1.listSonInstitutionRelDTO.push(institutionValue)
                                    });
                                    let institutionRelDTO = listSonInstitutionRelDTO[0];
                                    let sonInstitutionStaffDTO = institutionRelDTO.sonInstitutionStaffDTO;
                                    console.log(sonInstitutionStaffDTO.staffCode)
                                    this.$store.commit('update', ['activeStaffCode', sonInstitutionStaffDTO.staffCode]);
                                    window.localStorage.setItem('activeStaffCode', sonInstitutionStaffDTO.staffCode);
                                }
                                staffDTOCopy.institutionDTO=institutionDTO1
                            }
                        }
                        console.log(staffDTOCopy)
                        setToken(JSON.stringify(staffDTOCopy));
                        // var roleName=response.data.data.staffDTO.roleName
                        // if(roleName=='机构管理员'||roleName=='院长'){
                            this.$router.push({ path: loginForm.redirect || '/' })
                        // }else{
                        //     this.$router.push({ path: loginForm.redirect || '/' ,query:{isks: 'true'}})
                        // }
                        //获取全国地区列表

                    }else if(response.data.error == 1){
                        this.$message(response.data.message);
                    }else{
                        console.log(response.data.message);
                    }
                }).catch(function (error) {
                    console.log(error);
                });
            },
            getAreaList(){
                this.$axios({
                    method: 'post',
                    url: this.$institutionUrl+"Area/ListAll",
                    data: {
                        timeStr: timeStr,
                        sign: hex_md5("timeStr=" + timeStr + "&key="+this.$signKey),
                    }
                }).then(
                    (response) => {
                        if (response.data.error == 0) {
                            var data=JSON.stringify(response.data.data);
                            //data=JSON.parse(data.replace(/"listAreaDTO":\[\],/g,''))
                            data=data.replace(/"listAreaDTO":\[\],/g,'')
                            window.localStorage.setItem('areaValue', data);
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },
        }
    }

</script>

<style lang="scss" scoped>
    .dashboard-container{
        height: 100vh;
    }
</style>
